__turbopack_context__.v({
  "codeBlock": "krails-dashboard-module__Ul0pjq__codeBlock",
  "codeFunction": "krails-dashboard-module__Ul0pjq__codeFunction",
  "codeKeyword": "krails-dashboard-module__Ul0pjq__codeKeyword",
  "codeProperty": "krails-dashboard-module__Ul0pjq__codeProperty",
  "codeSection": "krails-dashboard-module__Ul0pjq__codeSection",
  "codeSectionTitle": "krails-dashboard-module__Ul0pjq__codeSectionTitle",
  "codeString": "krails-dashboard-module__Ul0pjq__codeString",
  "codeVariable": "krails-dashboard-module__Ul0pjq__codeVariable",
  "codeWithGutter": "krails-dashboard-module__Ul0pjq__codeWithGutter",
  "dashboardContainer": "krails-dashboard-module__Ul0pjq__dashboardContainer",
  "dashboardPanel": "krails-dashboard-module__Ul0pjq__dashboardPanel",
  "dashboardStack": "krails-dashboard-module__Ul0pjq__dashboardStack",
  "dashboardVignette": "krails-dashboard-module__Ul0pjq__dashboardVignette",
  "dot": "krails-dashboard-module__Ul0pjq__dot",
  "endpointHeader": "krails-dashboard-module__Ul0pjq__endpointHeader",
  "endpointIcon": "krails-dashboard-module__Ul0pjq__endpointIcon",
  "endpointPath": "krails-dashboard-module__Ul0pjq__endpointPath",
  "footerNav": "krails-dashboard-module__Ul0pjq__footerNav",
  "gutter": "krails-dashboard-module__Ul0pjq__gutter",
  "langIcon": "krails-dashboard-module__Ul0pjq__langIcon",
  "langLabelText": "krails-dashboard-module__Ul0pjq__langLabelText",
  "langTab": "krails-dashboard-module__Ul0pjq__langTab",
  "langTabActive": "krails-dashboard-module__Ul0pjq__langTabActive",
  "langTabContent": "krails-dashboard-module__Ul0pjq__langTabContent",
  "langTabDots": "krails-dashboard-module__Ul0pjq__langTabDots",
  "langTabs": "krails-dashboard-module__Ul0pjq__langTabs",
  "languageIcon": "krails-dashboard-module__Ul0pjq__languageIcon",
  "languageLabel": "krails-dashboard-module__Ul0pjq__languageLabel",
  "languageSection": "krails-dashboard-module__Ul0pjq__languageSection",
  "metaInfo": "krails-dashboard-module__Ul0pjq__metaInfo",
  "methodBadge": "krails-dashboard-module__Ul0pjq__methodBadge",
  "navArrow": "krails-dashboard-module__Ul0pjq__navArrow",
  "navBadge": "krails-dashboard-module__Ul0pjq__navBadge",
  "navGroup": "krails-dashboard-module__Ul0pjq__navGroup",
  "navGroupTitle": "krails-dashboard-module__Ul0pjq__navGroupTitle",
  "navGroupTitleIcon": "krails-dashboard-module__Ul0pjq__navGroupTitleIcon",
  "navIcon": "krails-dashboard-module__Ul0pjq__navIcon",
  "navItem": "krails-dashboard-module__Ul0pjq__navItem",
  "navItemActive": "krails-dashboard-module__Ul0pjq__navItemActive",
  "navList": "krails-dashboard-module__Ul0pjq__navList",
  "navPath": "krails-dashboard-module__Ul0pjq__navPath",
  "panelContent": "krails-dashboard-module__Ul0pjq__panelContent",
  "panelOne": "krails-dashboard-module__Ul0pjq__panelOne",
  "panelOverlay": "krails-dashboard-module__Ul0pjq__panelOverlay",
  "panelThree": "krails-dashboard-module__Ul0pjq__panelThree",
  "panelTwo": "krails-dashboard-module__Ul0pjq__panelTwo",
  "responseContent": "krails-dashboard-module__Ul0pjq__responseContent",
  "responseItem": "krails-dashboard-module__Ul0pjq__responseItem",
  "responseList": "krails-dashboard-module__Ul0pjq__responseList",
  "responseTitle": "krails-dashboard-module__Ul0pjq__responseTitle",
  "searchBox": "krails-dashboard-module__Ul0pjq__searchBox",
  "searchIcon": "krails-dashboard-module__Ul0pjq__searchIcon",
  "section": "krails-dashboard-module__Ul0pjq__section",
  "sectionHeading": "krails-dashboard-module__Ul0pjq__sectionHeading",
  "sectionTitle": "krails-dashboard-module__Ul0pjq__sectionTitle",
  "sidebarHeader": "krails-dashboard-module__Ul0pjq__sidebarHeader",
  "statusBadge": "krails-dashboard-module__Ul0pjq__statusBadge",
  "statusDot": "krails-dashboard-module__Ul0pjq__statusDot",
  "uploadIcon": "krails-dashboard-module__Ul0pjq__uploadIcon",
  "urlDisplay": "krails-dashboard-module__Ul0pjq__urlDisplay",
  "versionBadge": "krails-dashboard-module__Ul0pjq__versionBadge",
  "windowChrome": "krails-dashboard-module__Ul0pjq__windowChrome",
  "windowDots": "krails-dashboard-module__Ul0pjq__windowDots",
});
